module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liveAwards"
    }
  }, [_c('h1', [_vm._v("企業獎即時分流")]), _vm._v(" "), _c('p', [_vm._v("各企業獎報名數量限制為 20 專案，若超額將由各企業參考 HackingMap 專案介紹決定。")]), _vm._v(" "), _c('p', [_vm._v("因各企業獎的名額有限，可參考即時組數調整報名方向，提高獲獎機會")]), _vm._v(" "), _vm._l((_vm.awards), function(award, index) {
    return [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "center",
        "align": "middle",
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12,
        "xs": 20
      }
    }, [_c('div', {
      attrs: {
        "id": "counter"
      }
    }, [_c('h3', [_vm._v(" " + _vm._s(award) + "：" + _vm._s(_vm.awardsLength[index]) + " ")]), _vm._v(" "), _c('el-progress', {
      attrs: {
        "percentage": _vm.awardsLength[index] / 20 * 100,
        "show-text": false,
        "stroke-width": 8,
        "status": _vm.awardsLength[index] >= 20 ? 'exception' : ''
      }
    })], 1)])], 1)]
  }), _vm._v(" "), _c('span', [_vm._v("規則"), _c('el-input', {
    model: {
      value: (_vm.regex),
      callback: function($$v) {
        _vm.regex = $$v
      },
      expression: "regex"
    }
  })], 1), _vm._v(" "), _c('ol', _vm._l((_vm.postWithoutHost), function(post) {
    return _c('li', [_vm._v(_vm._s(post))])
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4128c6aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveAwards.vue
// module id = 969
// module chunks = 1